module.exports = __webpack_public_path__ + "static/starWalker-4e24e1582edf66cec3687f1e70b8ec8a.jpg";